import { queryKey } from 'Shared/const/queryKey';
import { type ServiceRequest, serviceApi, withServiceRequestDefaults } from 'Shared/network';
import { useQueryClient } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import type {
  ConfirmPostViewingRecordUpdatedGuidelineResponse,
  ViewingApiConfirmPostViewingRecordUpdatedGuidelineRequest,
} from 'viewup-api/v2';
import type { MutationParam } from 'viewup-lib/common';
import type { ErrorResponse } from 'viewup-lib/lib';
import { useSDMutation } from 'viewup-lib/react';

export type ConfirmGuidelineReq =
  ServiceRequest<ViewingApiConfirmPostViewingRecordUpdatedGuidelineRequest>;

export const useConfirmGuideline = (
  params?: MutationParam<
    AxiosResponse<ConfirmPostViewingRecordUpdatedGuidelineResponse>,
    ErrorResponse<{ originCode: string; originMessage: string }>,
    ConfirmGuidelineReq
  >,
) => {
  const queryClient = useQueryClient();
  const mutationResult = useSDMutation({
    ...params?.options,
    mutationFn: async (params: ConfirmGuidelineReq) => {
      return await serviceApi.viewing.confirmPostViewingRecordUpdatedGuideline(
        withServiceRequestDefaults(params),
      );
    },
    onSuccess: (d, v, context) => {
      queryClient.invalidateQueries({
        queryKey: queryKey.posting.overviewList._def,
      });
      params?.options?.onSuccess?.(d, v, context);
    },
  });

  return mutationResult;
};
